export function isEffectivelyEmpty(value) {
    return (
      value === null ||
      value === undefined ||
      value === '' ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'object' &&
        value !== null &&
        Object.keys(value).length === 0)
    );
  }
  
  export function areValuesSemanticallySame(value1, value2) {
    if (isEffectivelyEmpty(value1) && isEffectivelyEmpty(value2)) {
      return true;
    }
  
    if (isEffectivelyEmpty(value1) !== isEffectivelyEmpty(value2)) {
      return false;
    }
  
    if (typeof value1 === 'number' && typeof value2 === 'string') {
      return value1 === Number(value2);
    }
  
    if (typeof value1 === 'string' && typeof value2 === 'number') {
      return Number(value1) === value2;
    }
  
    if (typeof value1 === 'boolean' && typeof value2 === 'string') {
      return value1 === (value2.toLowerCase() === 'true');
    }
  
    if (typeof value1 === 'string' && typeof value2 === 'boolean') {
      return (value1.toLowerCase() === 'true') === value2;
    }
  
    if (Array.isArray(value1) && Array.isArray(value2)) {
      if (value1.length !== value2.length) return false;
  
      for (let i = 0; i < value1.length; i++) {
        if (!areValuesSemanticallySame(value1[i], value2[i])) {
          return false;
        }
      }
      return true;
    }
  
    if (
      typeof value1 === 'object' &&
      value1 !== null &&
      typeof value2 === 'object' &&
      value2 !== null
    ) {
      return JSON.stringify(value1) === JSON.stringify(value2);
    }
  
    return value1 === value2;
  }
  

  export function flattenObjectWithPath(obj, prefix = '') {
    if (!obj || typeof obj !== 'object') {
      return {};
    }
  
    const flattened = {};
  
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        const newKey = prefix ? `${prefix} > ${key}` : key;
  
        if (
          typeof value === 'object' &&
          value !== null &&
          !Array.isArray(value)
        ) {
          Object.assign(flattened, flattenObjectWithPath(value, newKey));
        } else {
          flattened[newKey] = value;
        }
      }
    }
  
    return flattened;
  }